import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Background3D from './components/Background3D';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import UploadReport from './pages/UploadReport';
import About from './pages/About';
import Disclaimer from './pages/Disclaimer';
import { ApiKeyProvider } from './contexts/ApiKeyContext';
import './App.css';

function App() {
  return (
    <ApiKeyProvider>
      <Router>
        <div className="min-h-screen relative flex flex-col">
          <Background3D />
          <Navbar />
          <main className="relative z-10 flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/upload" element={<UploadReport />} />
              <Route path="/about" element={<About />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ApiKeyProvider>
  );
}

export default App;